import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CodeIcon from '../../assets/media/icons/code.svg'
import CartboxButton from '../cartbox-button'

export type Props = {
    saveConfiguration: Function
    configurationIsBuildable: boolean
    brand: string
}

const SaveConfigurationButton: FunctionComponent<Props> = (props) => {
    const { saveConfiguration, configurationIsBuildable } = props
    const { t } = useTranslation()

    const clickHandler = (): void => {
        saveConfiguration()
    }

    return (
        <>
            <CartboxButton
                onClick={clickHandler}
                disabled={!configurationIsBuildable}
                icon={<CodeIcon />}
                label={t(`cart.saveConfigurationButtonLabel`)}
                dataTestId="save-configuration-button"
            />
        </>
    )
}

export default SaveConfigurationButton
